import { Collapsible } from '@base-ui/react'
import { ArrowPathIcon, ChevronDownIcon } from '@heroicons/react/24/outline'
import { ReactNode, useState } from 'react'

type AdminFiltersProps = {
  isLoading: boolean
  onRefresh: () => void
  children: ReactNode
}

const AdminFilters = ({
  isLoading,
  onRefresh,
  children,
}: AdminFiltersProps) => {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <Collapsible.Root
      className="mb-4"
      open={isOpen}
      onOpenChange={open => setIsOpen(open)}
    >
      <div className="mb-3 flex items-center justify-between">
        <Collapsible.Trigger className="btn btn-ghost btn-sm flex items-center gap-2">
          <ChevronDownIcon
            className={`h-4 w-4 transition-transform ${isOpen ? '' : '-rotate-90'}`}
          />
          {isOpen ? 'Hide Filters' : 'Show Filters'}
        </Collapsible.Trigger>
        <button
          className="btn btn-primary btn-sm flex items-center gap-2"
          onClick={onRefresh}
          disabled={isLoading}
          type="button"
        >
          <ArrowPathIcon className="h-4 w-4" />
          {isLoading ? 'Loading...' : 'Refresh'}
        </button>
      </div>
      <Collapsible.Panel className="flex flex-col gap-3">
        {children}
      </Collapsible.Panel>
    </Collapsible.Root>
  )
}

export type { AdminFiltersProps }
export { AdminFilters }
